import { parseQueryString, toQueryString } from '@muse-web/url'

type TQueryValue = string | number | boolean | null | undefined

/**
 * @param path API path, with or without a query string of its own.
 * @param params Params to merge in; they win over same-named params already in the path.
 * @returns The path with the merged query string.
 */
export const withQuery = (path: string, params: Record<string, TQueryValue>): string => {
    const [basePath, existingQuery = ''] = path.split('?')
    const present = Object.entries(params).filter(
        ([, value]) => value !== undefined && value !== null,
    )

    return `${basePath}${toQueryString({
        ...parseQueryString(existingQuery),
        ...Object.fromEntries(present),
    })}`
}
